import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { IConfig } from '@shared/interface/config.interface';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { apiGet } from './common/api';
import { ApiError } from '@shared/error/api.error';
import { manageApiError } from './common/api.lib';

/*****************************************
 *
 * GET FUNCTIONS
 *
 *****************************************/

// Get UI configuration
export const apiGetConfig = (): Promise<IConfig | undefined> => {
  const endpointClass = endpoints.config.getConfig;
  return apiGet(endpointClass.getUrl(), {
    publicApi: endpointClass.isPublic(),
  })
    .then((response?: IApiResponse<IConfig>) => {
      if (response != null && response.returnCode === 'CNF_GET_OK') {
        return Promise.resolve(response.returnSuccess);
      } else {
        throw new ApiError(response?.returnError ?? '', response?.returnCode);
      }
    })
    .catch((error: ErrorConstructor) => manageApiError(error, 'apiGetConfig'));
};
